import styles from "./ClubCarousel.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import SwiperCore, { Autoplay, Pagination, Navigation, FreeMode } from "swiper";
import useWindowResize from "../../hooks/useWindowResize";
import { useState, useRef } from "react";
import ButtonWithIcon from "../ButtonWithIcon/ButtonWithIcon";

SwiperCore.use([Autoplay, Pagination, Navigation, FreeMode]);

const ClubCarousel = ({ title, navigation, slides, rules, bigger = false, note }) => {
  const isBelowMedium = useWindowResize(768);
  const [slideSelected, setSlideSelected] = useState(0);

  const itemsRef = useRef([]);
  const swiperRef = useRef(null);

  //console.log(slides);
  // in caso di loop usare questa funzione
  // const handleClickNavigationItem = (e, index) => {
  //   setSlideSelected(index);
  //   // Switch to swiper slide (aggiunta 4 per gestire loop)
  //   swiperRef.current.swiper.slideTo(index + 3);
  // };

  const handleClickNavigationItem = (index) => {
    setSlideSelected(index);
    swiperRef.current.swiper.slideTo(index);
  };

  // in caso di loop usare questa funzione
  // const handleActiveIndexChange = (e) => {
  //   let realIndex = 0;
  //   if (e.activeIndex === 6) {
  //     // loop sulla prima
  //     realIndex = 0;
  //   } else if (e.activeIndex === 2) {
  //     // scorrimento carosello a ritroso
  //     realIndex = 2;
  //   } else {
  //     // -4 per loop swiper
  //     realIndex = e.activeIndex - 3;
  //   }
  //   // Tra gli items navigation bar sotto carosello Get item corrispondente alla slide corrente
  //   const activeItem = itemsRef.current[realIndex];
  //   // Set index della navbar
  //   setSlideSelected(realIndex);
  // };

  const handleActiveIndexChange = (e) => {
    setSlideSelected(e.activeIndex);
  };


  return (
    <div>
      {isBelowMedium ? (
        <div className={`${styles.ClubCarousel} clubCarousel`}>
          {title && <div className={styles.maintitle}>{title}</div>}
          <div className={styles.nav}>
            {navigation.map((d, i) => (
              <div
                key={i}
                className={
                  styles.item +
                  " " +
                  (slideSelected === i ? styles.selected : "")
                }
                onClick={() => handleClickNavigationItem(i)}
                ref={(ref) => (itemsRef.current[i] = ref)}
              >
                {d}
              </div>
            ))}
          </div>
          <div className={`cardCarouselWithCards ${styles.carousel}`} style={{overflow: 'hidden'}}>
            <Swiper
              slidesPerView={1}
              spaceBetween={0}
              slideToClickedSlide={true}
              // loop
              centeredSlides
              navigation
              centeredSlidesBounds={true}
              // pagination={mobileview}
              style={{margin: '0 25px', overflow: 'visible', width: 'calc(100% - 50px)'}}
              onActiveIndexChange={handleActiveIndexChange}
              ref={swiperRef}
            >
              {slides.map(
                (d, j) =>
                  d.items && (
                    <SwiperSlide
                      key={j}
                      className={styles.SwiperSlide + (slideSelected == j ? ' '+styles.current : '')}
                    // style={{
                    //   marginRight: slideSelected == 2 && j == 2 && "9rem",
                    //   marginLeft:
                    //     (slideSelected == 0 || slideSelected == 1) &&
                    //     j == 0 &&
                    //     "9rem",
                    // }}
                    >
                      <div className={styles.contentContainer}>
                        <img src={d.image.src} alt={d.image.alt}></img>
                        <div className={styles.title}>{d.title}</div>
                        <div className={styles.subtitle}>
                          {d.items[0]?.subtitle}
                        </div>
                        {/* <div dangerouslySetInnerHTML={{ __html: content[i] }}></div> */}
                        {d.items[0].texts?.map((t, i) => (
                          <div key={i} className={styles.text + (t.text?.trim() == '<p>NO</p>' ? ' '+styles.greyed : '')}>
                            <span
                              dangerouslySetInnerHTML={{ __html: t.title }}
                            ></span>
                            {t.text && t.text?.trim() != '<p>NO</p>' && <span
                              dangerouslySetInnerHTML={{ __html: t.text }}
                            ></span>}
                          </div>
                        ))}
                      </div>
                      <div
                        className={styles.noteSection}
                        dangerouslySetInnerHTML={{
                          __html: note,
                        }}
                      ></div>
                      <div className={styles.presenttitle}>
                        {d.items[1]?.subtitle}
                      </div>
                      {d.items[1].texts?.map((r, l) => (
                        <div key={l} className={styles.text + (r.text?.trim() == '<p>NO</p>' ? ' '+styles.greyed : '')}>
                          <span
                            dangerouslySetInnerHTML={{ __html: r.title }}
                          ></span>
                          {r.text && r.text?.trim() != '<p>NO</p>' && <span
                            dangerouslySetInnerHTML={{ __html: r.text }}
                          ></span>}
                        </div>
                      ))}
                    </SwiperSlide>
                  )
              )}
            </Swiper>
          </div>
        </div>
      ) : (
        <div
          className={`${styles.ClubCarousel} clubCarousel ${bigger ? styles.biggerClubCarousel : null
            }`}
        >
          {title && <div className={styles.maintitle}>{title}</div>}
          <div
            className={`cardCarouselWithCards ${styles.carousel} ${bigger ? styles.biggerCarousel : null
              }`}
          >
            {slides.map(
              (d, j) =>
                d.items && (
                  <div key={j} className={styles.SwiperSlide + (slideSelected == j ? ' '+styles.current : '')}>
                    <div className={styles.contentContainer} onClick={() => { setSlideSelected(j)}}>
                      <img src={d.image.src} alt={d.image.alt}></img>
                      <div className={styles.title}>{d.title}</div>
                      <div className={styles.subtitle}>
                        {d.items[0]?.subtitle}
                      </div>
                      {/* <div dangerouslySetInnerHTML={{ __html: content[i] }}></div> */}
                      {false && d.items[0].texts?.map((t, i) => (
                        <div key={i} className={styles.text}>
                          <div
                            dangerouslySetInnerHTML={{ __html: t.title }}
                          ></div>
                          <div
                            dangerouslySetInnerHTML={{ __html: t.text }}
                          ></div>
                        </div>
                      ))}
                    </div>
                    {false && <div className={styles.subtitle}>
                      {d.items[1]?.subtitle}
                    </div>}
                    {false && d.items[1].texts?.map((r, l) => (
                      <div key={l} className={styles.text}>
                        <span
                          dangerouslySetInnerHTML={{ __html: r.title }}
                        ></span>
                        {<span dangerouslySetInnerHTML={{ __html: r.text }}></span>}
                      </div>
                    ))}
                  </div>
                )
            )}
          </div>
          <div className={styles.tableflex}>
            <div className={styles.tablelist}>{slides.map(
              (d, j) =>
                d.items && <div style={{ display: slideSelected == j ? 'block' : 'none'}}>
                  {d.items[0].texts?.map((t, i) => (
                    <div key={i} className={styles.row}>
                      <div>
                        <span className={t.text?.trim() == '<p>NO</p>' ? styles.greyed : ''}
                          dangerouslySetInnerHTML={{ __html: t.title }}
                        ></span>
                        {t.text && t.text?.trim() != '<p>NO</p>' && <span
                          dangerouslySetInnerHTML={{ __html: t.text }}
                        ></span>}
                      </div>
                      {slides.map( (q, w) => <div key={w} className={styles.dots + (slideSelected == w ? ' '+styles.dotcurrent : '')}>{q.items[0].texts?.[i]?.text?.trim() != '<p>NO</p>' ? <span></span> : ''}</div> )}
                      
                    </div>
                  ))}
                  <div
                    className={styles.noteSection}
                    dangerouslySetInnerHTML={{
                      __html: note,
                    }}
                  ></div>
                  <div className={styles.presenttitle}>{d.items[1]?.subtitle}</div>

                  {d.items[1].texts?.map((r, l) => (
                    <div key={l} className={styles.row}>
                      <div>
                        <span
                          dangerouslySetInnerHTML={{ __html: r.title }}
                        ></span>
                        {r.text && r.text?.trim() != '<p>NO</p>' && <span dangerouslySetInnerHTML={{ __html: r.text }}></span>}
                      </div>
                      {slides.map( (q, w) => <div key={w} className={styles.dots + (slideSelected == w ? ' '+styles.dotcurrent : '')}>{q.items[1].texts?.[l]?.text?.trim() != '<p>NO</p>' ? <span></span> : ''}</div> )}
                    </div>
          
                  ))}

                  </div>
            )}</div>

            
              {false && slides.map((d,j) => <div key={j} className={styles.dotscolumn + (slideSelected == j ? ' '+styles.dotcurrent : '')}>
                {d.items[0].texts?.map( (t, i) => <div key={i}>o</div> )}
              </div>)}
            
          </div>

        </div>
      )}
      
      {rules && (
        <div className={styles.registerSection}>
          <a
            href={rules.items[0]?.url}
            target={rules.items[0]?.target}
            className={styles.rules}
          >
            {rules.items[0]?.title}
          </a>
          <ButtonWithIcon
            link={rules.items[1]}
            style={{
              width: "210px",
              boxSizing: "border-box",
              height: "55px",
              marginBottom: "2.8rem",
            }}
          />
          <div className={styles.login}>
            {rules.subtitle}
            <a href={rules.items[2]?.url} target={rules.items[2]?.target}>
              {" "}
              {rules.items[2]?.title}
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClubCarousel;
